// Layout for the plan surfaces at the three demo widths.
//
// CSS-only, no JavaScript width branching: the surfaces render identically in a
// jsdom test and on a phone, and there is no breakpoint state to fall out of
// sync. Colour, type and spacing all come from the design-system tokens; nothing
// here invents a value.
//
// 360 (phone) · 768 (tablet) · 1280 (desktop) — the widths the bead names.
export const planStylesheet = `
.plan-surface { display: grid; gap: var(--space-16, 1rem); min-width: 0; }
.plan-week__days, .plan-week__list, .plan-need-list, .plan-availability__list,
.plan-event__needs, .plan-need__responsible { list-style: none; margin: 0; padding: 0; }
.plan-week__days, .plan-week__day, .plan-week__list, .plan-week__list > li { min-width: 0; }
.plan-week__list { display: grid; gap: var(--space-16, 1rem); }

/* UX-006 / plan §14.4: the agenda is a sequence of local days, each announced.
   The heading is sticky so the day a card belongs to stays readable while a long
   day scrolls — the same reason the printed pack repeats its date. */
.plan-week__days { display: grid; gap: var(--space-24, 1.5rem); }
.plan-week__day { display: grid; gap: var(--space-8, 0.5rem); }
.plan-week__day-heading {
  position: sticky; top: 0; z-index: 1; margin: 0;
  padding-block: var(--space-4, 0.25rem);
  background: var(--color-surface, #ffffff);
  border-bottom: 1px solid var(--color-border, #d7ded9);
  color: var(--color-ink-muted, #5b6862);
  font-size: var(--font-size-14, 0.875rem); font-weight: 600; letter-spacing: 0.06em;
}

.plan-need { display: grid; gap: var(--space-4, 0.25rem);
  padding: var(--space-12, 0.75rem) 0; border-top: 1px solid var(--color-border, #d7ded9); }
.plan-need__label { font-weight: 600; margin: 0; }
.plan-need__window { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem); margin: 0; }
.plan-need__status { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); margin: 0; }
.plan-need__proxy, .plan-availability__proxy { color: var(--color-ink-muted, #5b6862); }

.plan-availability__row { display: grid; gap: var(--space-4, 0.25rem);
  padding: var(--space-12, 0.75rem) 0; border-top: 1px solid var(--color-border, #d7ded9); }

/* Tablet: the plan reads two-up, and availability becomes a scannable row. */
@media (min-width: 768px) {
  .plan-week__list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .plan-availability__row {
    grid-template-columns: minmax(8rem, 1fr) auto auto minmax(6rem, 1fr) auto;
    align-items: baseline; gap: var(--space-12, 0.75rem);
  }
}

/* Desktop: a readable measure rather than full-bleed. Plan §21.6 caps the
   planning workspace around 1280 and ordinary reading around 720. */
@media (min-width: 1280px) {
  .plan-surface { max-width: min(100%, 1280px); }
  .plan-week__list { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  /* A day heading spanning its own columns, not sharing a card's. */
  .plan-week__day-heading { grid-column: 1 / -1; }
  .plan-event-detail__facts, .plan-need-list { max-width: 720px; }
}
`;
